import { render, staticRenderFns } from "./popover-pre-doc.vue?vue&type=template&id=5d232901&scoped=true"
import script from "./popover-pre-doc.vue?vue&type=script&lang=js"
export * from "./popover-pre-doc.vue?vue&type=script&lang=js"
import style0 from "./popover-pre-doc.vue?vue&type=style&index=0&id=5d232901&lang=scss"
import style1 from "./popover-pre-doc.vue?vue&type=style&index=1&id=5d232901&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d232901",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d232901')) {
      api.createRecord('5d232901', component.options)
    } else {
      api.reload('5d232901', component.options)
    }
    module.hot.accept("./popover-pre-doc.vue?vue&type=template&id=5d232901&scoped=true", function () {
      api.rerender('5d232901', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/correspondence/popover-pre-doc.vue"
export default component.exports